/**
 * @what manipulate the system (js engine)
 * @why important for global errors
 */
angular
  .module('utility-ng-configuration')
  .provider('FaultToleranceConfiguration', function FaultToleranceConfigurationProvider(log, $provide) {
    var configuration;
    var DEFAULTS = {
      captureErrors: false,
      failFast: false
    };

    var configure = (this.configure = function configuration__FaultToleranceConfiguration(userConfig) {
      if (!!userConfig) {
        configuration = _.merge({}, DEFAULTS, userConfig);
      }

      return configuration;
    });

    this.activate = function activate_FaultToleranceConfiguration(userConfig) {
      this.configure(userConfig);

      if (!!angular && !!configuration.captureErrors) {
        return;
      }

      $provide.decorator('$exceptionHandler', [
        '$delegate',
        function ($delegate) {
          return function (exception, cause) {
            $delegate(exception, cause);

            if (_.isFunction(log.fatal)) {
              log.system.fatal(exception.message, cause);
            }

            if (!!configuration.failFast && EABError) {
              EABError.FAIL('application', 105, {
                message: exception.message,
                cause: cause
              });
            }
          };
        }
      ]);

      return configuration;
    };

    this.$get = function () {
      return {};
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/src/configuration/fault_tolerance_configuration.js